// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable func-names, babel/camelcase */
import Payment from "@kiwicom/frontend-app/scripts/containers/mutable/Payment"

export type PaymentInput = {
  original_price: number
  credits_payment: number
  card_payment: number
  original_currency: string
  price: number
}

export default function ({
  original_price,
  credits_payment,
  card_payment,
  original_currency,
  price,
}: PaymentInput): Payment {
  return new Payment({
    amount: original_price || credits_payment,
    credits: credits_payment,
    cardPaymentAmount: card_payment,
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    currency: original_currency && original_currency.toLowerCase(),
    amountInEur: price,
  })
}
